import { createStyles, Theme } from '@material-ui/core';

export const styles = (theme: Theme) =>
  createStyles({
    primary: {
      color: theme.palette.primary.main
    },
    secondary: {
      color: theme.palette.secondary.main
    },
    warning: {
      color: theme.palette.warning.main
    },
    info: {
      color: theme.palette.info.main
    },
    error: {
      color: theme.palette.error.main
    },
    grey: {
      color: theme.palette.grey[600]
    }
  });
